import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../config";
import "./OurProducts.css";

function OurProducts({ limit }) {
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${API_BASE_URL}/api/products`)
      .then((res) => res.json())
      .then((data) => {
        if (limit) {
          const shuffled = [...data].sort(() => 0.5 - Math.random());
          setProducts(shuffled.slice(0, limit));
        } else {
          setProducts(data);
        }
      })
      .catch((err) => console.error("Error fetching products:", err));
  }, [limit]);

  const getImageUrl = (imgPath) => {
    if (!imgPath) return "/placeholder.png";
    return `${API_BASE_URL}${imgPath}`;
  };

  return (
    <section className="products-page">
      {/* 1. HERO SECTION */}
      <div className="section-hero">
        <h2 className="flytutor-main-heading">Drone Fleet Solutions</h2>
      </div>

      {/* 2. ACTUAL PRODUCTS GRID (White Section) */}
      {products.length > 0 ? (
        <div className="section-light">
          <div className="content-inner">
            <div className="products-grid">
              {products.map((p) => (
                <div className="product-card" key={p._id}>
                  <div className="card-image">
                    <span className="category-badge">{p.category || 'Professional'}</span>
                    <div className="card-status-badge">✓ Certified</div>
                    <img src={getImageUrl(p.image)} alt={p.name} />
                  </div>
                  <div className="card-body">
                    <div className="title-row">
                      <h3 className="product-title">{p.name}</h3>
                      <span className="product-price">₹{p.price?.toLocaleString() || 'Ask for Price'}</span>
                    </div>
                    <p className="product-description">
                      {p.description || 'Enterprise-grade UAV solution for advanced industrial and agricultural operations.'}
                    </p>
                    <div className="product-specs-mini">
                      <span>⏱️ 25m Flight</span>
                      <span>📷 HD Camera</span>
                      <span>🛰️ GPS Pro</span>
                    </div>
                    <button
                      className="product-btn"
                      onClick={() => navigate(`/product-quote-template/${p._id}`)}
                    >
                      Request Enterprise Quote
                    </button>
                  </div>
                </div>
              ))}
            </div>
            {limit && (
               <button className="view-all-btn" onClick={() => navigate("/sales")}>
                 Explore Full Catalog
               </button>
            )}
          </div>
        </div>
      ) : (
        <div className="section-light" style={{ padding: '80px 4vw' }}>
          <div className="content-inner" style={{ textAlign: 'center' }}>
            <div className="no-products-box">
              <div className="no-products-icon">📦</div>
              <h3 style={{ fontSize: '1.8rem', fontWeight: '800', marginBottom: '10px' }}>Inventory Currently Updating</h3>
              <p style={{ color: '#64748b', fontSize: '1.1rem', maxWidth: '600px', margin: '0 auto 30px' }}>
                We are currently recalibrating our strategic UAV fleet. The next generation of DGCA-certified drones will be available for deployment shortly.
              </p>
              <button 
                className="cta-btn" 
                style={{ padding: '14px 30px', margin: '0 auto' }}
                onClick={() => navigate('/contact')}
              >
                Inquire for Pre-Orders
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 3. VANGUARD FLEET (Gray Section) - Shows if no products or as extra info */}
      <div className={products.length > 0 ? "section-gray" : "section-light"}>
        <div className="content-inner">
          <div className="empty-header">
            <h3>Vanguard Fleet Arriving</h3>
            <p>Establishing the next generation of DGCA-approved UAV technology for the Indian market.</p>
          </div>
          <div className="coming-soon-grid">
            <div className="cs-card">
              <div className="cs-icon">🌾</div>
              <h4>Agri-Series</h4>
              <p>Autonomous spraying systems with precision AI mapping.</p>
            </div>
            <div className="cs-card">
              <div className="cs-icon">🏗️</div>
              <h4>Industrial Pro</h4>
              <p>High-thermal sensors for mission-critical infrastructure.</p>
            </div>
            <div className="cs-card">
              <div className="cs-icon">🎓</div>
              <h4>Training Kits</h4>
              <p>Standardized flight controllers for pilot certification.</p>
            </div>
          </div>
        </div>
      </div>

      {/* 4. THE ADVANTAGE (White Section) */}
      <div className="section-light">
        <div className="content-inner">
          <h2 className="flytutor-main-heading" style={{ fontSize: '2.5rem', marginBottom: '60px' }}>The Flytutor Advantage</h2>
          <div className="prop-grid">
            <div className="prop-item">
              <h4>📜 DGCA Certified</h4>
              <p>Every system strictly adheres to the Ministry of Civil Aviation's latest compliance frameworks.</p>
            </div>
            <div className="prop-item">
              <h4>🛠️ Enterprise Support</h4>
              <p>On-site maintenance and 24/7 technical assistance for mission-critical drone fleets.</p>
            </div>
            <div className="prop-item">
              <h4>🎓 Strategic Training</h4>
              <p>Comprehensive pilot orientation and flight authorization support included with enterprise sales.</p>
            </div>
          </div>
        </div>
      </div>

      {/* 5. CUSTOM SOLUTIONS (Gray Section) */}
      <div className="section-gray">
        <div className="content-inner">
          <div className="custom-cta">
              <div className="cta-content">
                <h3>Need a Custom Solution?</h3>
                <p>Our engineering team can build custom UAV payloads specifically for your industry needs.</p>
                <button className="cta-btn" onClick={() => navigate('/contact')}>Consult Our Engineers</button>
              </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default OurProducts;
